const contactFrench = () => ({
  title: 'Prenez contact',
  formText:
      "Question, commentaire ou préoccupation ? Laissez-moi un message via le formulaire. Je serai ravi d'entendre de vous.",
  fromInput: {
    name: 'Votre nom',
    mail: 'E-mail',
    message: 'Message',
  },
});

export default contactFrench;
